module.exports = __webpack_public_path__ + "static/media/excedentes.5fec6c3a.svg";